import { render } from "./FormValidated.vue?vue&type=template&id=a5246eba&ts=true"
import script from "./FormValidated.vue?vue&type=script&lang=ts"
export * from "./FormValidated.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__